import React from 'react';
import { Head } from 'modules/shared/components/Head';
import { Navigation } from 'modules/shared/components/Navigation/Navigation';
import { usePageAccess } from 'modules/shared/hooks/usePageAccess';
import { ALLOWED_SCOPES } from 'constants/roles';

const AdminLayout = ({ allowedScopes = [], title = 'Admin Portal', children }) => {
  usePageAccess(allowedScopes?.length ? allowedScopes : ALLOWED_SCOPES);

  return (
    <Navigation>
      <Head title={title} />
      {children}
    </Navigation>
  );
};

export default AdminLayout;
